// Страница управления dashboard-пользователями. SPEC §8.3, §9.2.
// Список юзеров + кнопка «Добавить» (открывает AddUserDialog, который
// требует подтверждения текущего пароля).

import { useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '../../components/ui/button.tsx';
import { useUsers } from '../../lib/hooks.ts';
import { AddUserDialog } from './AddUserDialog.tsx';

export function UsersPage(): JSX.Element {
  const [dialogOpen, setDialogOpen] = useState(false);
  const usersQ = useUsers();

  return (
    <div className="space-y-6">
      <header className="flex items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Пользователи</h1>
          <p className="mt-1 text-sm text-fg-muted">
            Доступ к дашборду. Каждый юзер настраивает свой 2FA при первом входе.
          </p>
        </div>
        <Button variant="primary" onClick={() => setDialogOpen(true)}>
          <Plus className="h-4 w-4" />
          Добавить
        </Button>
      </header>

      {usersQ.isPending ? (
        <div className="text-sm text-fg-muted">Загружаем…</div>
      ) : usersQ.isError ? (
        <div className="rounded border border-danger/40 bg-danger/10 p-3 text-sm text-danger">
          Не удалось загрузить список пользователей.
        </div>
      ) : (
        <div className="overflow-hidden rounded border border-border">
          <table className="w-full text-sm">
            <thead className="bg-bg-soft text-left text-xs uppercase tracking-wide text-fg-muted">
              <tr>
                <th className="px-3 py-2 font-medium">Email</th>
                <th className="px-3 py-2 font-medium">Роль</th>
                <th className="px-3 py-2 font-medium">Создан</th>
                <th className="px-3 py-2 font-medium">Последний вход</th>
              </tr>
            </thead>
            <tbody>
              {usersQ.data.items.map((u) => (
                <tr key={u.id} className="border-t border-border">
                  <td className="px-3 py-2 font-mono text-xs">{u.email}</td>
                  <td className="px-3 py-2">{u.role}</td>
                  <td className="px-3 py-2 text-fg-muted">{formatDate(u.createdAt)}</td>
                  <td className="px-3 py-2 text-fg-muted">
                    {u.lastLoginAt ? formatDate(u.lastLoginAt) : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <AddUserDialog open={dialogOpen} onOpenChange={setDialogOpen} />
    </div>
  );
}

function formatDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleString('ru-RU', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}
